module.exports = __webpack_public_path__ + "static/media/brand-list.js.a8196cd1.bak";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/brands/brand-list.js.bak
// module id = 2127
// module chunks = 0